import React, { useEffect, useState } from 'react';
import GeoclientQuote from './GeoclientQuote';

const GeoclientQuotes = ({ isLoading, isLoadingErr, quotes, onQuoteEdit, getQuoteInfo }) => {
  return (
    <div id="quotes" className="quotes">
      {isLoading ? (
        <div className="quotes__error">Загрузка...</div>
      ) : isLoadingErr ? (
        <div className="quotes__error">
          Ошибка при загрузке, попробуйте еще раз
        </div>
      ) : (
        <>
          {quotes ? (
            <>
              {quotes.map((quoteItem) => {
                return (
                  <GeoclientQuote
                    key={quoteItem.created_at}
                    quoteItem={quoteItem}
                    onQuoteEdit={onQuoteEdit}
                    getQuoteInfo={getQuoteInfo}
                  />
                );
              })}
            </>
          ) : (
            <div className="quotes__error">
              Вы еще не создали ни одной геоподборки
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default GeoclientQuotes;
